import type {ReactElement} from 'react';

import {NumberInput} from '@/components/common/Input';
interface PercentageInputProps {
  onValueChange?: (
    rawValue: string,
    e?: React.ChangeEvent<HTMLInputElement>,
  ) => void; // optional callback for raw number
  value?: string;
  label?: string;
  /** Test hook placed on the underlying number `<input>`. */
  dataCy?: string;
}

const PercentageInput = ({
  label,
  onValueChange,
  value,
  dataCy,
}: PercentageInputProps): ReactElement => {
  return (
    <div>
      <label
        htmlFor="price"
        className="block text-sm font-medium leading-6 text-gray-700 dark:text-gray-200"
      >
        {label}
      </label>
      <div className="relative mt-1 rounded-md shadow-sm">
        <NumberInput
          name="percent"
          id="percent"
          dataCy={dataCy}
          value={value || ''}
          min={0}
          max={100}
          className="block w-full rounded-md border-0 p-2.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 dark:bg-transparent dark:text-gray-100 dark:ring-gray-600 dark:placeholder:text-gray-500 dark:focus:ring-indigo-400 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          placeholder="0.00"
          onValueChange={onValueChange}
        />
        <div className="absolute inset-y-0 right-0 flex items-center">
          <label htmlFor="currency" className="sr-only">
            %
          </label>
        </div>
      </div>
    </div>
  );
};

export default PercentageInput;
